import { render, staticRenderFns } from "./PdfHeader.vue?vue&type=template&id=6befa42c&scoped=true&"
import script from "./PdfHeader.vue?vue&type=script&lang=js&"
export * from "./PdfHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6befa42c",
  null
  
)

export default component.exports